import SocialSecurity from './SocialSecurity'

export default SocialSecurity
